export const PROFILE_DATA_FETCHED = 'myAccount.PROFILE_DATA_FETCHED';
export const PROFILE_DATA_FETCH_FAILED = 'myAccount.PROFILE_DATA_FETCH_FAILED';
export const CLEAR_PROFILE_DATA = 'myAccount.CLEAR_PROFILE_DATA';
